/* eslint-disable array-callback-return */
import React, { Component } from "react";
import "./ScoreKomp.css";
import { HOST } from "./../../config";

class ScoreKomp extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      showMark: false,
      SCORE: null,
      ScoreCourse: null,
      ScoreSemester: null,
      ESTIMATION: null,
      ERROR: null,
      ESTIMATIONfetch: null,
      DETAILvalue: null,
      DETAILname: null,
      DETAILfetch: false,
    };
  }

  componentDidMount() {
    let SCORE = this.props.SCORE.reduce(function (r, a) {
      r[a.id_a_year] = r[a.id_a_year] || [];
      r[a.id_a_year].push(a);
      return r;
    }, Object.create(null));

    let scor = Object.keys(SCORE).map((key) => [Number(key), SCORE[key]]);
    this.setState({
      SCORE: scor,
    });

    setTimeout(() => {
      let currentIndex = scor.findIndex((x) => x[0] == this.props.YEAR);
      currentIndex = currentIndex != -1 ? currentIndex : 0;
      this.table(currentIndex);
      this.semester(currentIndex);
    }, 0);
  }

  handleChange = (event) => {
    const datasetId =
      event.target.options[event.target.selectedIndex].dataset.id;
    this.table(parseInt(datasetId));
    this.semester(parseInt(datasetId));
  };

  // /personalcard
  toggleMark = () => {
    this.setState({ showMark: !this.state.showMark });
  };

  handleChangeMark = (event) => {
    const est = event.target.options[event.target.selectedIndex].dataset.id;
    this.markDetail(...this.state.ESTIMATIONattr, est);
  };

  markDetail = (year, semester, discipline, credit, student, group, est) => {
    this.setState({ DETAILfetch: true });
    fetch(`${HOST}/markdetail.json`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        year,
        semester,
        discipline,
        credit,
        id: student,
        group,
        est,
      }),
    })
      .then((res) => res.json())
      .then((json) => {
        if (json.error) {
          this.setState({
            DETAILvalue: null,
            DETAILname: null,
            ERROR: "Ошибка не найдено!",
            DETAILfetch: false,
          });
        } else {
          this.setState({
            DETAILvalue: json.data[0][0],
            DETAILname: json.data[1],
            DETAILfetch: false,
          });
        }
      });
  };

  markEst = (year, semester, discipline, credit, student, group, name) => {
    this.setState({ ESTIMATIONfetch: true });
    fetch(`${HOST}/markest.json`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        year,
        semester,
        discipline,
        credit,
        id: student,
        group,
      }),
    })
      .then((res) => res.json())
      .then((json) => {
        if (json.error) {
          this.setState({
            ESTIMATION: null,
            ESTIMATIONattr: null,
            ERROR: "Ошибка не найдено!",
            ESTIMATIONfetch: false,
          });
        } else {
          if (json.data.length) {
            this.setState({
              ESTIMATION: json.data,
              ESTIMATIONfetch: false,
              showMark: true,
              ESTIMATIONname: name,
              ESTIMATIONattr: [
                year,
                semester,
                discipline,
                credit,
                student,
                group,
              ],
            });
            this.markDetail(
              year,
              semester,
              discipline,
              credit,
              student,
              group,
              json.data.slice(-1).pop().id_f_est
            );
          } else
            this.setState({
              ESTIMATION: null,
              ERROR: "Ошибка нет записей!",
              ESTIMATIONfetch: false,
              ESTIMATIONattr: null,
            });
        }
      });
  };

  markDetailInfo = () => {
    const { DETAILfetch, DETAILname, DETAILvalue } = this.state;
    // console.log("markDetailInfo start", DETAILfetch, DETAILname, DETAILvalue)
    // if (DETAILfetch) {
    //   // console.log("markDetailInfo 1");
    //   return null
    // }
    if (!DETAILfetch && !DETAILvalue) {
      // console.log("markDetailInfo 2");
      return null;
    }
    if (!DETAILfetch && DETAILname.length == 0) {
      // console.log("markDetailInfo 3", !DETAILfetch, DETAILname, DETAILname.length, DETAILname.length == 0);
      return (
        <table>
          <tr>
            <th>Общий балл</th>
          </tr>
          <tr>
            <td>{Math.round(this.state.DETAILvalue.ball1 * 100) / 100}</td>
          </tr>
        </table>
      );
    }
    if (!DETAILfetch && DETAILname.length > 0) {
      // console.log("markDetailInfo 4", !DETAILfetch, DETAILname, DETAILname.length, DETAILname.length > 0);
      return (
        <table>
          <tr>
            {this.state.DETAILname.map((name) => {
              // console.log("markDetailInfo name 1", name, name.name_pole);
              return <th>{name.name_pole}</th>;
            })}
          </tr>
          <tr>
            {this.state.DETAILname.map((name) => {
              // console.log("markDetailInfo name 2", name, this.state.DETAILvalue[name.pole_mark_mag]);
              return (
                <td>
                  {" "}
                  {Math.round(
                    (this.state.DETAILvalue[name.pole_mark_mag] * 100) / 100
                  )}
                </td>
              );
            })}
          </tr>
        </table>
      );
    }
    // console.log("markDetailInfo end")
  };

  groupByKey = (list, key, { omitKey = false }) =>
    list.reduce(
      (hash, { [key]: value, ...rest }) => ({
        ...hash,
        [value]: (hash[value] || []).concat(
          omitKey ? { ...rest } : { [key]: value, ...rest }
        ),
      }),
      {}
    );
  /////////////////////////////////////////////////////////////////////////////
  semester(index) {
    const { SCORE } = this.state;

    if (SCORE) {
      let semester = Object.entries(
        this.groupByKey(SCORE[index][1], "id_semester", { omitKey: true })
      );

      let ScoreSemester1 = [];
      let ScoreSemester2 = [];
      let ScoreSemester3 = [];
      let ScoreSemester4 = [];

      let ScoreData1 = [];
      let ScoreData2 = [];
      let ScoreData3 = [];
      let ScoreData4 = [];


      let TotalScore1 = [];
      let TotalScore2 = [];
      let TotalScore3 = [];
      let TotalScore4 = [];


      ScoreSemester1.push(
        <tr className="Score_Sem">
          <th colSpan="7">{semester[0][1][0].p43}</th>
        </tr>
      );
      if (semester[1]) {
        ScoreSemester2.push(
          <tr className="Score_Sem">
            <th colSpan="7">{semester[1][1][0].p43}</th>
          </tr>
        );
      }
      if (semester[2]) {
        ScoreSemester3.push(
          <tr className="Score_Sem">
            <th colSpan="7">{semester[2][1][0].p43}</th>
          </tr>
        );
      }
      if (semester[3]) {
        ScoreSemester4.push(
          <tr className="Score_Sem">
            <th colSpan="7">{semester[3][1][0].p43}</th>
          </tr>
        );
      }
      // /personalcard
      for (let a = 0; a < semester[0][1].length; a++) {
        ScoreData1.push(
          <tr className="Scores">
            <td>{a + 1}</td>
            <td>
              {semester[0][1][a].p34} [{semester[0][1][a].Krdt} кр.]
            </td>
            <td>{semester[0][1][a].p54}</td>
            <td>{semester[0][1][a].p30}</td>
            <td
              onClick={() =>
                this.markEst(
                  semester[0][1][a].id_a_year,
                  semester[0][0],
                  semester[0][1][a].id_discipline,
                  semester[0][1][a].Krdt,
                  semester[0][1][a].id_student,
                  semester[0][1][a].id_group,
                  semester[0][1][a].p34
                )
              }
              title="Посмотреть подробнее..."
              style={{
                textDecoration: "underline",
                cursor: "pointer",
                fontWeight: "600",
              }}
            >
              {semester[0][1][a].ball}
            </td>
            <td>{semester[0][1][a].p31}</td>
            <td>{semester[0][1][a].p36}</td>
          </tr>
        );
      }
      if (semester[1]) {
        for (let a = 0; a < semester[1][1].length; a++) {
          ScoreData2.push(
            <tr className="Scores">
              <td>{a + 1}</td>
              <td>
                {semester[1][1][a].p34} [{semester[1][1][a].Krdt} кр.]
              </td>
              <td>{semester[1][1][a].p54}</td>
              <td>{semester[1][1][a].p30}</td>
              <td
                onClick={() =>
                  this.markEst(
                    semester[1][1][a].id_a_year,
                    semester[1][0],
                    semester[1][1][a].id_discipline,
                    semester[1][1][a].Krdt,
                    semester[1][1][a].id_student,
                    semester[1][1][a].id_group,
                    semester[1][1][a].p34
                  )
                }
                title="Посмотреть подробнее..."
                style={{
                  textDecoration: "underline",
                  cursor: "pointer",
                  fontWeight: "600",
                }}
              >
                {semester[1][1][a].ball}
              </td>
              <td>{semester[1][1][a].p31}</td>
              <td>{semester[1][1][a].p36}</td>
            </tr>
          );
        }
      }
      if (semester[2]) {
        for (let a = 0; a < semester[2][1].length; a++) {
          ScoreData3.push(
            <tr className="Scores">
              <td>{a + 1}</td>
              <td>
                {semester[2][1][a].p34} [{semester[2][1][a].Krdt} кр.]
              </td>
              <td>{semester[2][1][a].p54}</td>
              <td>{semester[2][1][a].p30}</td>
              <td
                onClick={() =>
                  this.markEst(
                    semester[2][1][a].id_a_year,
                    semester[2][0],
                    semester[2][1][a].id_discipline,
                    semester[2][1][a].Krdt,
                    semester[2][1][a].id_student,
                    semester[2][1][a].id_group,
                    semester[2][1][a].p34
                  )
                }
                title="Посмотреть подробнее..."
                style={{
                  textDecoration: "underline",
                  cursor: "pointer",
                  fontWeight: "600",
                }}
              >
                {semester[2][1][a].ball}
              </td>
              <td>{semester[2][1][a].p31}</td>
              <td>{semester[2][1][a].p36}</td>
            </tr>
          );
        }
      }
      if (semester[3]) {
        for (let a = 0; a < semester[3][1].length; a++) {
          ScoreData4.push(
            <tr className="Scores">
              <td>{a + 1}</td>
              <td>
                {semester[3][1][a].p34} [{semester[3][1][a].Krdt} кр.]
              </td>
              <td>{semester[3][1][a].p54}</td>
              <td>{semester[3][1][a].p30}</td>
              <td
                onClick={() =>
                  this.markEst(
                    semester[3][1][a].id_a_year,
                    semester[3][0],
                    semester[3][1][a].id_discipline,
                    semester[3][1][a].Krdt,
                    semester[3][1][a].id_student,
                    semester[3][1][a].id_group,
                    semester[3][1][a].p34
                  )
                }
                title="Посмотреть подробнее..."
                style={{
                  textDecoration: "underline",
                  cursor: "pointer",
                  fontWeight: "600",
                }}
              >
                {semester[3][1][a].ball}
              </td>
              <td>{semester[3][1][a].p31}</td>
              <td>{semester[3][1][a].p36}</td>
            </tr>
          );
        }
      }
      let Sum1 = 0;
      for (let a = 0; a < semester[0][1].length; a++) {
        Sum1 = Sum1 + semester[0][1][a].Krdt;
      }
      TotalScore1.push(
        <tr className="Total_Score">
          <td colSpan="7">
            Итого зарегистрированных кредитов за {semester[0][1][0].p43}: {Sum1}
          </td>
        </tr>
      );
      let Sum2 = 0;
      if (semester[1]) {
        for (let a = 0; a < semester[1][1].length; a++) {
          Sum2 = Sum2 + semester[1][1][a].Krdt;
        }
        TotalScore2.push(
          <tr className="Total_Score">
            <td colSpan="7">
              Итого зарегистрированных кредитов за {semester[1][1][0].p43}:{" "}
              {Sum2}
            </td>
          </tr>
        );
      }
      let Sum3 = 0;
      if (semester[2]) {
        for (let a = 0; a < semester[2][1].length; a++) {
          Sum3 = Sum3 + semester[2][1][a].Krdt;
        }
        TotalScore3.push(
          <tr className="Total_Score">
            <td colSpan="7">
              Итого зарегистрированных кредитов за {semester[2][1][0].p43}:{" "}
              {Sum3}
            </td>
          </tr>
        );
      }

      let Sum4 = 0;
      if (semester[3]) {
        for (let a = 0; a < semester[3][1].length; a++) {
          Sum4 = Sum4 + semester[3][1][a].Krdt;
        }
        TotalScore4.push(
          <tr className="Total_Score">
            <td colSpan="7">
              Итого зарегистрированных кредитов за {semester[3][1][0].p43}:{" "}
              {Sum4}
            </td>
          </tr>
        );
      }
      this.setState({ ScoreSemester1 });
      this.setState({ ScoreData1 });
      this.setState({ TotalScore1 });

      this.setState({ ScoreSemester2 });
      this.setState({ ScoreData2 });
      this.setState({ TotalScore2 });


      this.setState({ ScoreSemester3 });
      this.setState({ ScoreData3 });
      this.setState({ TotalScore3 });

      this.setState({ ScoreSemester4 });
      this.setState({ ScoreData4 });
      this.setState({ TotalScore4 });

    }
  }

  /////////////////////////////////////////////////////////
  table(index) {
    const { SCORE } = this.state;

    let ScoreCourse;

    if (SCORE) {
      ScoreCourse = (
        <tr className="Year_Course">
          <td colSpan="4">{SCORE[index][1][0].p32} учебный год</td>
          <td colSpan="3">{SCORE[index][1][0].p22}</td>
        </tr>
      );

      this.setState({ ScoreCourse });
    }
  }

  // <!--
  //   <script>
  //   if (window.__REACT_DEVTOOLS_GLOBAL_HOOK__)
  //     window.__REACT_DEVTOOLS_GLOBAL_HOOK__.inject = function () {};
  // </script>

  render() {
    if (this.state.SCORE) {
      // /personalcard
      return (
        <div className="scoreWrapper">
          {this.state.showMark && (
            <div className="markDetailWrapperDesktop" onClick={this.toggleMark}>
              <div
                className="markDetailDesktop"
                onClick={(e) => e.stopPropagation()}
              >
                <div className="markDetailCloseDesktop">
                  <div onClick={this.toggleMark}>
                    <div id="mdiv">
                      <div class="mdiv">
                        <div class="md"></div>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="markDetailSelectDesktop">
                  <select
                    onChange={this.handleChangeMark}
                    className="select-css-desktop"
                  >
                    {this.state.ESTIMATION.map((est, index) => {
                      return (
                        <option
                          data-id={est.id_f_est}
                          selected={!this.state.ESTIMATION[index + 1]}
                        >
                          {/* selected last item */}
                          {est.f_est}
                        </option>
                      );
                    })}
                  </select>
                </div>
                <div className="markDetailInfoDesktop">
                  <p>{this.state.ESTIMATIONname}</p>
                  {this.markDetailInfo()}
                </div>
              </div>
            </div>
          )}

          <div className="Select_Year">
            <label>Oценки за</label>
            <select onChange={this.handleChange}>
              {this.state.SCORE.map((year, index) => {
                return (
                  <option data-id={index} selected={year[0] == this.props.YEAR}>
                    {year[1][0].p32} учебный год
                  </option>
                );
              })}
            </select>
          </div>
          <div className="Score_table">
            <table>
              <tbody>
                <tr className="Score_header">
                  <th>№ </th>
                  <th>Дисциплина</th>
                  <th>Кол. час</th>
                  <th>Форма контроля</th>
                  <th>Количество баллов</th>
                  <th>Оценка</th>
                  <th>Дата сдачи</th>
                </tr>
                {this.state.ScoreCourse}
                {this.state.ScoreSemester1}
                {this.state.ScoreData1}
                {this.state.TotalScore1}
                {this.state.ScoreSemester2}
                {this.state.ScoreData2}
                {this.state.TotalScore2}
                {this.state.ScoreSemester3}
                {this.state.ScoreData3}
                {this.state.TotalScore3}
                {this.state.ScoreSemester4}
                {this.state.ScoreData4}
                {this.state.TotalScore4}
              </tbody>
            </table>
          </div>
        </div>
      );
    } else return null;
  }
}

export default ScoreKomp;
